// extracted by mini-css-extract-plugin
export var container = "header-module--container--XLnQW";
export var line = "header-module--line--OIGVx";
export var name = "header-module--name--uy5-G";
export var nameLink = "header-module--name-link--RVbUX";
export var navLinkItem = "header-module--nav-link-item--I972B";
export var navLinks = "header-module--nav-links--mDou8";